export const animationDelayMilliseconds = 5000
export const fasterAnimationDelayMilliseconds = 3000
